<template>
  <v-dialog
    v-model="showDialog"
    max-width="600"
    scrollable
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-bind="$attrs"
        :class="$vuetify.breakpoint.mdAndDown && cardDesktop ? 'body-2 px-0' : ''"
        :outlined="outlined"
        block
        color="primary"
        data-cy="bt_abrir_modal_download"
        v-on="on"
      >
        Baixar meus arquivos
      </v-btn>
    </template>
    <v-card data-cy="modal_download">
      <v-card-title class="title pb-1 pl-5 pt-5 grey--text text--darken-4">
        Baixar meus arquivos
      </v-card-title>
      <v-card-text class="px-3 pb-0">
        <v-list dense class="py-0">
          <v-list-item
            v-for="(download, index) in downloads"
            :key="index"
            three-line
            :href="download.url"
            :class="`d-flex justify-start mb-3 blue-grey lighten-5 text-none download-${index}`"
            download
            target="_blank"
            data-cy="button_baixar_arquivos"
            dense
            depressed
            tile
            @click="downloadRealizado(index)"
          >
            <v-icon
              x-small
              left
            >
              fas fa-download
            </v-icon>
            <v-list-item-content>
              <v-list-item-subtitle class="subtitle-2">
                {{ download.file_name }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions class="py-0">
        <v-spacer />
        <v-btn
          color="primary"
          text
          class="grey--text text--darken-2 mb-2 mt-1"
          @click="showDialog = false"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api';

export default {
  name: 'BtnBaixarAquivos',

  props: {
    downloads: {
      type: Array,
      required: true,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    cardDesktop: {
      type: Boolean,
      default: false,
    },
    vendaId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      showDialog: false,
    };
  },

  methods: {
    async scoreConsumidor(orderId) {
      await api.post('/consumer_score', {
        action: 'membertizze_digital_products',
        orderId,
      });
    },

    downloadRealizado(index) {
      this.scoreConsumidor(this.vendaId);
    },
  },
};
</script>
